var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26626_59552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.13 30.8101H0.5V61.6201H139.13V30.8101Z",
    fill: "#161617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13 0H0.5V30.81H139.13V0Z",
    fill: "#354F9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13 61.61H0.5V92.42H139.13V61.61Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26626_59552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.63,
    height: 92.42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEe);
export default __webpack_public_path__ + "static/media/Flag_EE.854f7105289fd6e418d4a462d2269898.svg";
export { ForwardRef as ReactComponent };